import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Chip, Skeleton, Typography } from "@mui/material";
import EventNoteIcon from "@mui/icons-material/EventNote";
import InboxIcon from "@mui/icons-material/Inbox";
import moment from "moment/moment";

function DialogFechas(props) {
  const { id_provincia, provincia, open, onClose } = props;
  const [isLoading, setisLoading] = useState(false);
  const [fechas, setFechas] = useState([]);

  const getFechasProvincia = useCallback(async () => {
    setisLoading(true);
    try {
      const response = await axios.get(
        UrlApi + "/padron/info-fechas/" + id_provincia
      );
      setFechas(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setisLoading(false);
    }
  }, [id_provincia]);

  useEffect(() => {
    if (open) getFechasProvincia();
  }, [getFechasProvincia, open]);

  const headerCellSx = {
    backgroundColor: "#1F618D",
    color: "#ffffff",
    fontWeight: 700,
    fontSize: "0.82rem",
    letterSpacing: "0.03em",
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
    >
      {/* Header del dialog */}
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #1F618D 0%, #2980B9 100%)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          py: 2,
        }}
      >
        <EventNoteIcon />
        <Box>
          <Typography variant="h6" fontWeight={700} lineHeight={1}>
            Historial de cargas
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.8 }}>
            {provincia}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        {isLoading ? (
          <Box sx={{ p: 3 }}>
            {[1, 2, 3, 4].map((n) => (
              <Skeleton
                key={n}
                animation="wave"
                height={44}
                sx={{ mb: 0.5, borderRadius: 1 }}
              />
            ))}
          </Box>
        ) : fechas.length === 0 ? (
          /* Empty state */
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 8,
              color: "text.secondary",
            }}
          >
            <InboxIcon sx={{ fontSize: 56, mb: 1.5, opacity: 0.35 }} />
            <Typography variant="h6" color="text.secondary" fontWeight={500}>
              Sin registros
            </Typography>
            <Typography variant="body2" color="text.disabled" mt={0.5}>
              No se encontraron cargas previas para {provincia}
            </Typography>
          </Box>
        ) : (
          <TableContainer component={Paper} elevation={0}>
            <Table aria-label="fechas padron">
              <TableHead>
                <TableRow>
                  <TableCell sx={headerCellSx}>Última Carga</TableCell>
                  <TableCell sx={headerCellSx}>Fecha Emisión</TableCell>
                  <TableCell sx={headerCellSx}>Vigencia Desde</TableCell>
                  <TableCell sx={headerCellSx}>Vigencia Hasta</TableCell>
                  <TableCell sx={{ ...headerCellSx, textAlign: "center" }}>
                    Registros
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fechas.map((row, idx) => (
                  <TableRow
                    key={row.id ?? idx}
                    sx={{
                      "&:nth-of-type(even)": { backgroundColor: "#F4F8FB" },
                      "&:last-child td": { border: 0 },
                      "&:hover": { backgroundColor: "#EAF4FB" },
                      transition: "background-color 0.15s",
                    }}
                  >
                    <TableCell>
                      {moment(row.ultima_carga).format("DD/MM/YYYY")}
                    </TableCell>
                     <TableCell>
                      {moment(row.fecha_emision).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell>
                      {moment(row.fecha_vigencia_desde).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell>
                      {moment(row.fecha_vigencia_hasta).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={row.registros_insertados?.toLocaleString() ?? "-"}
                        size="small"
                        sx={{
                          backgroundColor: "#EAF4FB",
                          color: "#1F618D",
                          fontWeight: 700,
                          fontSize: "0.78rem",
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #eee" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="error"
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogFechas;
